import React, { Component } from 'react';
import { ColumnProps } from 'primereact/column';
import moment from 'moment';
import CustomTable from '../../custom/CustomTable';
import CustomTableContentWrapper from '../../custom/CustomTableContentWrapper';
import { WatchlistListsModel } from '../../../domain/watchlist/WatchlistDomains';
import LanguageUtil from '../../../util/LanguageUtil';

class WatchlistListLogComponent extends Component<Props> {
  public render() {
    const lists = this.props.lists.filter((list: WatchlistListsModel) => list.size > 0);
    return (
      <div className={'w-full h-full p-5'}>
        <div className={'!max-h-[calc(100vh-20rem)] h-full overflow-y-scroll'}>
          <CustomTable value={lists} columns={this.getColumns()} multiSortMeta={[{ field: 'lastChangedDate', order: -1 }]} />
        </div>
      </div>
    );
  }

  private formatDate = (timestamp: number): string => {
    if (timestamp == undefined || timestamp <= 0) {
      return '';
    }
    return moment(timestamp).format('LLLL');
  };

  private getColumns = (): ColumnProps[] => {
    return [
      {
        field: 'name',
        className: 'min-w-[300px]',
        header: LanguageUtil.get({ id: 'common.label.name', defaultMessage: 'Name' }),
        body: (list: WatchlistListsModel) => {
          return (
            <div className={'text-xs 2xl:text-md'}>
              <CustomTableContentWrapper text={list.name ?? ''} showEllipsis={true} />
            </div>
          );
        },
      },
      {
        field: 'categories',
        className: 'min-w-[220px]',
        header: LanguageUtil.get({ id: 'pages.watchlist.table.category', defaultMessage: 'Category' }),
        sortable: false,
        body: (list: WatchlistListsModel) => {
          return (
            <div className={'flex items-center gap-x-2'}>
              {(list.categories ?? []).map((value: string, index: number) => {
                return (
                  <span
                    key={index}
                    className={`flex text-xs shrink-0 2xl:text-md h-full justify-center px-[16px] py-[3px] items-center rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                  >
                    {value}
                  </span>
                );
              })}
            </div>
          );
        },
      },
      {
        field: 'authority',
        className: 'min-w-[300px]',
        header: LanguageUtil.get({ id: 'common.label.authority', defaultMessage: 'Authority' }),
        body: (list: WatchlistListsModel) => {
          return (
            <div className={'text-xs 2xl:text-md'}>
              <CustomTableContentWrapper text={list.authority ?? ''} clipSize={30} showEllipsis={true} />
            </div>
          );
        },
      },
      {
        field: 'country',
        className: 'min-w-[150px]',
        header: LanguageUtil.get({ id: 'pages.watchlist.listLog.country', defaultMessage: 'Country' }),
        body: (list: WatchlistListsModel) => {
          return (
            <div className={'text-xs 2xl:text-md'}>
              <CustomTableContentWrapper text={list.country ?? ''} />
            </div>
          );
        },
      },
      {
        field: 'size',
        className: 'min-w-[130px]',
        header: LanguageUtil.get({ id: 'pages.watchlist.listLog.recordCount', defaultMessage: 'Record Count' }),
        body: (list: WatchlistListsModel) => {
          return <div className={'text-xs 2xl:text-md'}>{list.size}</div>;
        },
      },
      {
        field: 'lastChangedDate',
        className: 'min-w-[300px]',
        header: LanguageUtil.get({ id: 'pages.watchlist.listLog.lastUpdate', defaultMessage: 'Last Update' }),
        body: (list: WatchlistListsModel) => {
          return (
            <div className={'text-xs 2xl:text-md'}>
              <CustomTableContentWrapper text={this.formatDate(list.lastChangedDate)} />
            </div>
          );
        },
      },
      {
        field: 'lastCheckedDate',
        className: 'min-w-[300px]',
        header: LanguageUtil.get({ id: 'pages.watchlist.listLog.lastChecked', defaultMessage: 'Last Checked' }),
        body: (list: WatchlistListsModel) => {
          return (
            <div className={'text-xs 2xl:text-md'}>
              <CustomTableContentWrapper text={this.formatDate(list.lastCheckedDate)} />
            </div>
          );
        },
      },
    ];
  };
}

interface Props {
  lists: WatchlistListsModel[];
}

export default WatchlistListLogComponent;
